import Sandbox from '@/components/Sandbox';

const CheckboxDemo = () => {
  return (
    <Sandbox
      title="Checkbox Demo"
      layout="split"
      size="wide"
      splitRatio={0.6}
      minPreviewHeight="10rem"
      dependencies={{
        'use-sound': '4.0.3',
        'react-spring': '9.7.3',
      }}
      files={{
        '/App.js': `
import React from 'react';
import useSound from 'use-sound';

import Checkbox from './Checkbox';

function CheckboxDemo() {
  const [isChecked, setIsChecked] = React.useState(false);

  const [playActive] = useSound('/sounds/pop-down.mp3', {
    volume: 0.25,
  });
  const [playOn] = useSound('/sounds/pop-up-on.mp3', {
    volume: 0.25,
  });
  const [playOff] = useSound('/sounds/pop-up-off.mp3', {
    volume: 0.25,
  });

  return (
    <Checkbox
      name="demo-checkbox"
      checked={isChecked}
      size={20}
      label="I agree to the terms"
      onChange={() => setIsChecked(!isChecked)}
      onMouseDown={playActive}
      onMouseUp={() => {
        isChecked ? playOff() : playOn();
      }}
    />
  );
}

export default CheckboxDemo;
        `,
        '/Checkbox.js': `
import React from 'react';
import { useSpring, animated } from 'react-spring';

import styles from './Checkbox.module.css';

function Checkbox({
  size = 18,
  name,
  checked,
  label,
  onChange,
  onMouseDown,
  onMouseUp,
}) {
  const [active, setActive] = React.useState(false);

  const springConfig = {
    tension: 400,
    friction: 22,
    clamp: !checked,
  };

  const filledScale = checked ? (active ? 1.4 : 1) : 0;
  const filledSpring = useSpring({
    transform: \`scale(\${filledScale})\`,
    config: springConfig,
  });

  const outlineScale = active ? 0.8 : 1;
  const outlineSpring = useSpring({
    transform: \`scale(\${outlineScale})\`,
    config: springConfig,
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.visibleContents}>
        <animated.div className={styles.visibleBox}
          style={{ width: size, height: size, ...outlineSpring }}
        >
          <animated.div
            className={styles.filled}
            style={filledSpring}
          />
        </animated.div>

        <span className={styles.text}>{label}</span>
      </div>
      <input
        type="checkbox"
        className={styles.realCheckbox}
        onMouseDown={() => {
          setActive(true);
          onMouseDown();
        }}
        onMouseUp={() => {
          setActive(false);
          onMouseUp();
        }}
        onChange={onChange}
        onClick={onChange}
      />
    </div>
  );
};

export default Checkbox;
        `,
        '/Checkbox.module.css': `
.wrapper {
  --color-gray-700: hsl(225deg 12% 40%);
  --color-gray-1000: hsl(225deg 15% 15%);
  --color-primary: hsl(240deg 95% 62%);

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.realCheckbox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.visibleContents {
  position: relative;
  display: flex;
  align-items: center;
}

.visibleBox {
  position: relative;
  border: 2px solid var(--color-gray-700);
  border-radius: 4px;
  margin-right: 8px;
}
.realCheckbox:hover + .visibleContents .visibleBox {
  border-color: var(--color-gray-1000);
}
.realCheckbox:focus-visible + .visibleContents .visibleBox {
  outline: 2px auto var(--color-primary);
  outline-offset: 2px;
}

.filled {
  position: absolute;
  z-index: 1;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  background: var(--color-primary);
  border-radius: 2px;
}
.text {
  font-size: 1rem;
  font-family: var(--font-family);
  color: var(--color-gray-700);
  white-space: nowrap;
}
`,
      }}
    />
  );
};

export default CheckboxDemo;
